import styles from "../dashboard/BpsAdminDashboard.module.scss";

type Props = {
	title: string;
};

// Stand-in for BPS admin pages that have no implementation yet. Each route swaps
// this out for its real page as the pages land.
export const BpsAdminPlaceholderPage: React.FC<Props> = ({ title }) => (
	<div className={styles.container}>
		<h1 className={styles.title}>{title}</h1>
		<p className={styles.subtitle}>Coming soon</p>
	</div>
);
